import { LoaderCircle } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export default function AuthGuard({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const checkAuth = useCallback(async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/me`,
        { credentials: "include" },
      );
      setIsAuthenticated(response.ok);
    } catch (error) {
      setIsAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (isAuthenticated === null) {
    return (
      <main className="auth-loading" data-testid="auth-loading">
        <LoaderCircle className="payment-spinner" size={28} />
      </main>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}
